import { batch } from 'react-redux';

import { SymbolSearchSortBy } from 'dashboard-services/api/dataStorage';
import { ActionService, CommonService, ReduxService } from 'dashboard-services/services';
import { globalActions } from 'primary-components';

import { basicDataStorageCreatorActions, saveDialogDataStorageCreatorActions } from 'actions/modules/dataStorage/creator';

export default (() => {

  const WILDCARD_COLUMN = "*"

  const CHANGE_VALUE = 'CHANGE_VALUE_BUILDER_DATA_STORAGE'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const ADD_ALL_TO_BASKET = 'ADD_ALL_TO_BASKET_BUILDER_DATA_STORAGE'
  const addAllToBasket = ActionService.makeActionCreator(ADD_ALL_TO_BASKET, 'provider')

  const setUpSymbolsResponse = symbolsResponseObj => dispatch => {
    const symbols = symbolsResponseObj?.pages?.flatMap(page => page?.items || []) || [],
          totalSize = symbolsResponseObj?.pages?.[symbolsResponseObj.pages.length - 1]?.totalSize || 0,
          longest = symbols.reduce((prev, curr) => prev > curr.groupName.length ? prev : curr.groupName.length, 0),
          symbolsMapped = symbols.map((item, index) => {
            const newItem = Object.assign({}, item);
            newItem.values = newItem.values.slice(0).sort()
            newItem.choosenColumns = dispatch(getDefaultValue(newItem.values.slice(0)))
            return ReduxService.updateObject(newItem, { index })
          })
    dispatch(symbolsResponse(symbolsMapped, longest < CommonService.MIN_REQUEST_SIZE ? longest : CommonService.MIN_REQUEST_SIZE))
    dispatch(changeValue(totalSize, 'symbolsTotalSize'))
  }

  const SYMBOLS_RESPONSE = 'SYMBOLS_RESPONSE_BUILDER_DATA_STORAGE'
  const symbolsResponse = ActionService.makeActionCreator(SYMBOLS_RESPONSE, 'items', 'longestGroup')

  const getSortString = groupName => (_, getState) => {
    let keys = []
    let mds = []
    const symbolsDisplay = getState().myAccountState.settingsState.symbolsDisplay
    if(!groupName || !symbolsDisplay[groupName]) {
      keys = Object.values(symbolsDisplay).reduce((prev, curr) => prev.concat(curr.keys || []), [])
      mds = Object.values(symbolsDisplay).reduce((prev, curr) => prev.concat(curr.mds || []), [])
    } else {
      keys = symbolsDisplay[groupName]?.keys || []
      mds = symbolsDisplay[groupName]?.mds || []
    }
    const nonDuplicateKeys = Array.from(new Set(keys.map(k => k.value)))
    const nonDuplicateMds = Array.from(new Set(mds.map(m => m.value)))
    let builder = nonDuplicateKeys.reduce((prev, curr) => curr ? prev.withSort(curr) : prev, new SymbolSearchSortBy.Builder()) || new SymbolSearchSortBy.Builder()
    builder = nonDuplicateMds.reduce((prev, curr) => curr ? prev.withMetadataSort(curr) : prev, builder) || new SymbolSearchSortBy.Builder()
    return builder.build().getSortBy()
  }

  const getDefaultValue = (values = []) => (dispatch, getState) => {
    const userColumns = getState().myAccountState.settingsState.columns
    if(String(userColumns?.[0]).trim() === WILDCARD_COLUMN) {
      return values.map(v => ({ value: v, label: v }));
    }
    const finded = values.find(val => userColumns.find(c => String(c).toLowerCase().trim() === String(val).toLowerCase().trim()))
    if(!finded) {
      const isWildcarded = userColumns.find(c => String(c).trim() === WILDCARD_COLUMN)
      if(isWildcarded) {
        return values.map(v => ({ value: v, label: v }))
      } else if(values[0]) {
        return [{ value: values[0], label: values[0] }]
      } else {
        return []
      }
    }
    return [{ value: finded, label: finded }]
  }

  const ADD_TO_BASKET = 'ADD_TO_BASKET_BUILDER_DATA_STORAGE'
  const addToBasket = (index, isIndex = true) => (dispatch, getState) => {
    const searchLocation = new URLSearchParams(window.location.search),
          provider = searchLocation.get("provider") || undefined
    if(isIndex) {
      const builderState = getState().dataStorageState.creatorState.builderState,
            item = builderState.symbols[index]
      item.choosenColumns.forEach(column => dispatch(addToBasketReducer(ReduxService.updateObject(item, { choosenColumns: [column], source: provider }))))
    } else {
      dispatch(addToBasketReducer(index))
    }
  }
  const addToBasketReducer = ActionService.makeActionCreator(ADD_TO_BASKET, 'item')

  const ADD_TO_BASKET_AT_INDEX = 'ADD_TO_BASKET_AT_INDEX_DATA_STORAGE'
  const addToBasketAtIndex = ActionService.makeActionCreator(ADD_TO_BASKET_AT_INDEX, 'item', 'index')

  const REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET_BUILDER_DATA_STORAGE'
  const removeFromBasket = ActionService.makeActionCreator(REMOVE_FROM_BASKET, 'index')

  const CHANGE_COLUMNS = 'CHANGE_COLUMNS_BUILDER_DATA_STORAGE'
  const changeColumns = ActionService.makeActionCreator(CHANGE_COLUMNS, 'value', 'index')

  const basicDownloadFormats = [{
    label: "Standard",
    value: "STANDARD"
  }, {
    label: "Ncsv",
    value: "NCSV"
  }]

  const roundingModes = [{
    label: "Up",
    value: "UP"
  }, {
    label: "Down",
    value: "DOWN"
  }, {
    label: "Ceiling",
    value: "CEILING"
  }, {
    label: "Floor",
    value: "FLOOR"
  }, {
    label: "Half up",
    value: "HALF_UP"
  }, {
    label: "Half even",
    value: "HALF_EVEN"
  }]

  const REORDER_BASKET_ITEM = 'REORDER_BASKET_ITEM_BUILDER_DATA_STORAGE'
  const reorderBasketItem = ActionService.makeActionCreator(REORDER_BASKET_ITEM, 'to', 'from')

  const CHANGE_BASKET_ITEM = 'CHANGE_BASKET_ITEM_BUILDER_DATA_STORAGE'
  const changeBasketItem = ActionService.makeActionCreator(CHANGE_BASKET_ITEM, 'value', 'name', 'index')

  const play = ({ createCall, updateCall, executeCall, navigate, withDownload = false }) => (dispatch, getState) => {
    const { id, saved, executing } = getState().dataStorageState.creatorState.basicState,
          basket = getState().dataStorageState.creatorState.builderState.basket,
          { name, groupName } = getState().dataStorageState.creatorState.saveDialogState
    if(executing || basket.length === 0) {
      return Promise.resolve();
    }
    const playLocal = id => 
      executeCall({ id })
        .then(response => {
          const { pathname, hash, search } = window.location
          const searchParams = new URLSearchParams(search)
          searchParams.set("jobId", response?.jobId || "")
          navigate(pathname + "?" + searchParams.toString() + hash)
          dispatch(basicDataStorageCreatorActions.changeValue(true, 'executing'))
          return response?.jobId
        })
        .then(jobId => {
          dispatch(globalActions.getMessageStore()).success(`Your data prep is running.${withDownload ? " Downloading the file will start soon." : ""}`)
          return jobId
        })
        .then(() => withDownload && dispatch(basicDataStorageCreatorActions.changeValue(true, 'downloadListenerEnable')))
    if(saved && id !== undefined) {
      return playLocal(id)
    } else {
      dispatch(globalActions.getToastsStore()).info(
        `There are some unsaved changes. To ${withDownload ? "download" : "run"} the data prep ${withDownload ? "result " : ""}it needs to be saved first.`,
        "Data prep not saved",
        {
          withCancel: false,
          confirmText: `Save and ${withDownload ? "download" : "run"}`,
          confirmAction: () => {
            if(name && groupName) {
              dispatch(saveDialogDataStorageCreatorActions.save({ createCall, updateCall, navigate }))
                .then(id => playLocal(id))
            } else {
              batch(() => {
                dispatch(saveDialogDataStorageCreatorActions.changeValue(true, "isOpen"))
                dispatch(saveDialogDataStorageCreatorActions.changeValue(playLocal, "onSubmitOuter"))
              })
            }
          }
        }
      );
    }
  }

  const columnHeadersOptionsMap = {
    SYMBOL: "Symbol",
    COLUMN: "Column",
    GROUP: "Group"
  }

  const columnHeadersOptions = [{
    label: columnHeadersOptionsMap.SYMBOL,
    value: columnHeadersOptionsMap.SYMBOL
  }, {
    label: columnHeadersOptionsMap.COLUMN,
    value: columnHeadersOptionsMap.COLUMN
  }, {
    label: columnHeadersOptionsMap.GROUP,
    value: columnHeadersOptionsMap.GROUP
  }]

  const getGroupWidth = longestGroup => (longestGroup * 8 + 38) < 106 ? 106 : (longestGroup * 8 + 38)

  const isGroupFilterApplied = basket => basket.length === 1 && basket[0].groupName && Object.keys(basket[0].symbols || {}).length === 0 && Object.keys(basket[0].metadata || {}).length === 0
  
  return {
    changeValue,
    CHANGE_VALUE,
    addAllToBasket,
    ADD_ALL_TO_BASKET,
    setUpSymbolsResponse,
    getSortString,
    SYMBOLS_RESPONSE,
    addToBasket,
    ADD_TO_BASKET,
    changeColumns,
    CHANGE_COLUMNS,
    basicDownloadFormats,
    roundingModes,
    REORDER_BASKET_ITEM,
    reorderBasketItem,
    removeFromBasket,
    REMOVE_FROM_BASKET,
    CHANGE_BASKET_ITEM,
    changeBasketItem,
    ADD_TO_BASKET_AT_INDEX,
    addToBasketAtIndex,
    play,
    columnHeadersOptions,
    columnHeadersOptionsMap,
    getGroupWidth,
    isGroupFilterApplied
  }
})()